import { render, staticRenderFns } from "./ConnectPrimeTrust.vue?vue&type=template&id=e2cd949a&"
import script from "./ConnectPrimeTrust.vue?vue&type=script&lang=js&"
export * from "./ConnectPrimeTrust.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports